export default "__VITE_ASSET__3Y5UKCAB__"